/*
 * Put-item.ts
 * Description: Includes the declaration
 * of function for updating an item in the cart
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting an item from the cart
 *
 * @return {Object} Promise - refreshed cart
 * @param {Number} id - cart id
 * @param {String} slug - id of the restaurant
 * @param {Number} quantity - number of the same item
 */
export function putItem(id: number, slug: string, quantity: number) {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url: APIURL + 'carts/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                guest_id: localStorage.getItem(slug),
                quantity,
            },
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
